import styled from "styled-components";

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-shrink: 0;
  padding: ${({ styleButton }) =>
    styleButton.padding ? styleButton.padding : "0"};
  font-weight: ${({ styleButton }) =>
    styleButton.weight ? styleButton.weight : "bold"};
  cursor: pointer;
  font-size: ${({ styleButton }) =>
    styleButton.fontSize ? styleButton.fontSize : "23"}px;
  color: ${({ styleButton, theme }) =>
    styleButton.selected
      ? theme.palette.neutral.lightest
      : styleButton.textColor
      ? styleButton.textColor
      : theme.palette.neutral.darker};
  background-color: ${({ styleButton, theme }) =>
    styleButton.selected
      ? theme.palette.neutral.darkest
      : styleButton.color
      ? styleButton.color
      : theme.palette.tertiary.main};
  height: ${({ styleButton }) =>
    styleButton.height ? styleButton.height : "86"}px;
  width: ${({ styleButton }) =>
    styleButton.width ? styleButton.width : "393"}px;
  border: ${({ styleButton }) =>
    styleButton.border ? styleButton.border : "none"};
  border-radius: ${({ styleButton }) =>
    styleButton.borderRadius ? styleButton.borderRadius : "none"};
  border-color: ${({ styleButton }) =>
    styleButton.borderColor ? styleButton.borderColor : "none"};

  :hover {
    opacity: 1;
    background-color: ${({ styleButton, theme }) =>
      styleButton.hoverColor
        ? styleButton.hoverColor
        : theme.palette.primary.main};
    color: ${({ styleButton, theme }) =>
      styleButton.hoverTextColor
        ? styleButton.hoverTextColor
        : theme.palette.neutral.lightest};
  }
`;
